import { Component, inject } from "@angular/core";
import { ExportBase } from "../export-base";
import { ExportType } from "@enums/ExportType";
import { PermissionsService } from "@services/permissions/PermissionsService";
import { CerrixPromptService } from "@app/shared/services/cerrix-prompt.service";
import { StandingdataDataService } from "@app/standingdata/shared/standingdata.service";
import { GenericListFieldType } from "@app/shared/models/GenericList/GenericListField";
import { ModuleType } from "@enums/ModuleType";
import { EventsRisksAndControlsModel } from "@app/export/shared/models/events-risks-and-controls-model";
import { nameof } from "@methods/jeffs-toolkit";
import { provideTranslocoScope, TranslocoPipe, TranslocoService } from "@jsverse/transloco";
import { FormsModule } from "@angular/forms";
import { MatCheckboxModule } from "@angular/material/checkbox";

@Component({
    selector: "export-events",
    templateUrl: "./export-events.component.html",
    styleUrls: ["./export-events.component.scss"],
    providers: [provideTranslocoScope("export")],
    imports: [TranslocoPipe, FormsModule, MatCheckboxModule]
})
export class ExportEventsComponent extends ExportBase {
    permService = inject(PermissionsService);
    private cerrixPrompt = inject(CerrixPromptService);
    private dataService = inject(StandingdataDataService);
    private transloco = inject(TranslocoService);

    includeChecked = false;

    downloadEvent(type: ExportType) {
        const extra = `includedeletedandclosedmois=${this.includeChecked}`;
        this.exportDataService.downloadExport(type, extra);
    }

    exportEventsRisksAndControls(): void {
        this.cerrixPrompt
            .prompt({
                height: "fit-content",
                data: {
                    title: this.transloco.translate("export.events.eventsRisksControlsTitle"),
                    message: this.transloco.translate("export.selectOrgsMessage"),

                    fields: [
                        {
                            prettyName: this.transloco.translate("export.organizationsField"),
                            fieldName: nameof<EventsRisksAndControlsModel>((x) => x.organizations),
                            fieldType: GenericListFieldType.MultiTree,
                            minLength: 1,
                            maxLength: 200,
                            required: true,
                            selfInit: true,
                            getDataMethod: () => {
                                return this.dataService.getOrganizations(ModuleType.LER);
                            },
                        },
                    ],
                    confirmButton: {
                        text: this.transloco.translate("export.downloadButton"),
                        icon: "fad fa-cloud-download",
                    },
                },
            })
            .toPromise()
            .then((result: EventsRisksAndControlsModel) => {
                if (!result) {
                    return;
                }

                const stringSections: string[] = [];
                if (result.organizations && result.organizations.length > 0) {
                    stringSections.push("organizations=" + result.organizations.join(";"));
                }

                const extraString = stringSections.length > 0 ? stringSections.join("&") : "";
                this.download(this.ExportType.EventsRisksAndControls, extraString);
            });
    }
}
